module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    staticClass: "chartjs",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2cfdddc2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/chartJS/chartJS.vue
// module id = 1199
// module chunks = 61